/*
 * Returns the title to use in the browser tab depending on what environment is in use
 */
export function getAppTitle(environmentName: string | undefined) {
    if (!environmentName) return "Nova"
    const capitalizeName = environmentName[0].toUpperCase() + environmentName.substring(1)
    return environmentName === "production"
        ? "Nova"
        : environmentName === "localhost"
          ? "Dev"
          : capitalizeName
}
